// Utils
import { required } from '@shopee/validators';
import { prettifyPhoneNumber } from '@shopee-user/authentication-utils';

// Constants

// Types
import { TypedFormConfig } from '@shopee/use-form-hook';
import { LoginByPasswordFormShape } from '@shopee-user/business-customization-types';

export const FORM_CONFIG: TypedFormConfig<LoginByPasswordFormShape> = {
  authKey: {
    type: 'string',
    initialValue: '',
    validators: [required('msg_auth_mandatory_field')],
    transform: (authKey: string) => prettifyPhoneNumber(authKey.trim()),
  },
  password: {
    type: 'string',
    initialValue: '',
    validators: [required('msg_auth_mandatory_field')],
  },
};
